module.exports = __webpack_public_path__ + "img/little_kickrs.b87e0f64.png";